import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";

export const useVendorBreadcrumbs = () => {
    const vendorList = useSelector((store: IRPStore) => store.vendor.list);
    const vendor = useSelector((store: IRPStore) => store.vendor.detail.vendor);
    const region = vendorList.region?.length === 1 ? vendorList.region[0] : undefined;

    const regionsList = [
        region?.stats?.region_type_voivodeship,
        region?.stats?.region_type_county,
        region?.stats?.region_type_city,
        region?.stats?.region_type_district,
        region?.stats?.region_type_housing_estate,
        region?.stats?.region_type_town
    ].filter(Boolean);

    return [
        {key: "Deweloperzy", name: "Deweloperzy", position: "2", url: rpAppLink.vendor.list()},
        ...regionsList.map((region, index) => ({
            key: region?.name ?? index,
            name: region?.name ?? "",
            position: (index + 3).toString(),
            url: rpAppLink.vendor.listFriendly({friendlySlug: region?.slug ?? ""})
        })),
        ...(vendor
            ? [
                  {
                      key: vendor.name,
                      name: vendor.name,
                      position: "3",
                      url: rpAppLink.vendor.detail.base({vendorSlug: vendor.slug, vendorId: vendor.id})
                  }
              ]
            : [])
    ];
};
import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";

export const useVendorBreadcrumbs = () => {
    const vendorList = useSelector((store: IRPStore) => store.vendor.list);
    const vendor = useSelector((store: IRPStore) => store.vendor.detail.vendor);
    const region = vendorList.region?.length === 1 ? vendorList.region[0] : undefined;

    const regionsList = [
        region?.stats?.region_type_voivodeship,
        region?.stats?.region_type_county,
        region?.stats?.region_type_city,
        region?.stats?.region_type_district,
        region?.stats?.region_type_housing_estate,
        region?.stats?.region_type_town
    ].filter(Boolean);

    return [
        {key: "Deweloperzy", name: "Deweloperzy", position: "2", url: rpAppLink.vendor.list()},
        ...regionsList.map((region, index) => ({
            key: region?.name ?? index,
            name: region?.name ?? "",
            position: (index + 3).toString(),
            url: rpAppLink.vendor.listFriendly({friendlySlug: region?.slug ?? ""})
        })),
        ...(vendor
            ? [
                  {
                      key: vendor.name,
                      name: vendor.name,
                      position: "3",
                      url: rpAppLink.vendor.detail.base({vendorSlug: vendor.slug, vendorId: vendor.id})
                  }
              ]
            : [])
    ];
};
